module.exports = __webpack_public_path__ + "img/jz_cjj_wx_jy.f3ee4e87.png";